import { createElement } from 'react'

import { attachmentIcon } from './attachments'

type Props = {
  filename: string
  mimeType?: string
  size: number
  className?: string
}

/** `createElement`, not `<Icon />`: the icon is picked during render, which
 * the react-hooks static-components rule rejects as a JSX tag (same pattern
 * as `AgentGlyph`). */
export const ChatAttachmentIcon = ({
  filename,
  mimeType,
  size,
  className
}: Props) =>
  createElement(attachmentIcon(filename, mimeType), {
    size,
    strokeWidth: 1.5,
    className,
    'aria-hidden': true
  })
